var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3276 11.0115L14.2714 11.1566C15.2071 11.5686 17.3077 13.2025 17.3077 16.4937C17.3077 19.593 14.6972 22.7157 10.5943 22.7157C5.49023 22.7157 3.73118 19.7288 3.73118 16.9853C3.73118 13.4693 6.1873 11.1285 6.1873 7.92623C6.17392 6.79366 5.77704 5.69913 5.06152 4.82153C4.34601 3.94393 3.35418 3.33516 2.24815 3.09473L2.16394 3.23986C2.56504 3.62933 2.8833 4.09595 3.09956 4.61167C3.31583 5.12738 3.42565 5.68154 3.42241 6.24082C3.42241 9.70059 0.507812 12.1585 0.507812 16.1285C0.507812 19.7849 3.06218 23.5116 10.4586 23.5116C17.0504 23.5116 20.5264 20.2812 20.5264 16.8448C20.5217 13.8954 18.4118 11.4 14.3276 11.0115Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4635 0.932617L10.3994 18.5705H10.5395L12.389 0.932617H8.4635Z",
    fill: "#0460A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.503134,
    y1: 13.3008,
    x2: 20.5217,
    y2: 13.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7685B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFB946"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ca12c19eb8796a3ee2f56b00c77ffed.svg";
export { ForwardRef as ReactComponent };